
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "PantryLoadingPullToRefresh",
  props: {
    /**  ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    show: {
      type: Boolean,
      default: false
    },
    topPosition: {
      type: Number,
      default: 0
    }
  },
  setup(_, context: SetupContext) {
    NativeClient.sendDebugLog("LoadingPullToRefresh start");
  }
});
